import type { PaymentHistory, PaymentStage } from '@paid-ui/types';

import { sortBy } from 'lodash';

type Claim = PaymentStage['claim'];

export const mergeClaimHistories = (claim?: Claim) => {
  if (!claim) {
    return [];
  }
  const paymentHistories = claim?.paymentHistory ?? [];
  const claimHistories = claim?.stateHistory ?? [];
  const retentionHistories = claim?.retentions ?? [];

  const mergedHistories: PaymentHistory[] = [
    ...claimHistories,
    ...paymentHistories,
    ...retentionHistories,
  ]?.map((item) => ({
    ...item,
    type: item?.type ?? undefined,
  }));

  return sortBy(mergedHistories, (item) => item.createdAt.valueOf()).reverse();
};
